export const environment = {
  production: false,
  url: 'https://admin.rh.homolog.acesso.io/svc2',
  url_benefits: 'https://admin.rh.homolog.acesso.io/api/benefits/v1',
  cdn_url: 'https://admin.rh.homolog.acesso.io/cdn2',
  identity_url: 'https://identityhomolog.acesso.io',
  base_url: 'https://benefits.rh.homolog.acesso.io',
  sign_url: 'https://signhom.acesso.io',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  redirect_uri: 'https://benefits.rh.homolog.acesso.io/preauthorize',
  base_ongoing_url: 'https://collaborators.rh.homolog.acesso.io',
  admission_url: 'https://admin.rh.homolog.acesso.io',
  collaborator_url:  '',
  sentry_key: 'N/A',
  launchDarklyClientId: '63ea74d9be4a22130ad5aa07',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
